import { Clock, Wrench } from 'lucide-react';

/**
 * Placeholder for domains that have no user-scoped backend capability yet.
 * States plainly what the surface will show and what backend work unblocks it.
 */
const BackendPendingNotice = ({
  title,
  needed,
}: {
  title: string;
  /** One line describing the missing backend param/endpoint. */
  needed: string;
}) => (
  <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
    <div className="flex items-center gap-3 border-b border-gray-100 bg-gray-50 px-5 py-3">
      <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
        <Wrench className="h-4 w-4" />
      </div>
      <div>
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
        <p className="text-xs text-gray-500">Not yet scoped to a single user</p>
      </div>
      <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-amber-50 px-2.5 py-1 text-xs font-medium text-amber-700">
        <Clock className="h-3 w-3" />
        Backend pending
      </span>
    </div>
    <div className="space-y-3 px-5 py-6">
      <p className="text-sm text-gray-600">
        This section is ready in the UI. It will populate for this user as soon as the backend
        can filter the domain by user.
      </p>
      <div className="rounded-lg border border-dashed border-amber-200 bg-amber-50/60 px-4 py-3">
        <p className="text-xs font-semibold uppercase tracking-wider text-amber-700">
          What&apos;s needed
        </p>
        <p className="mt-1 text-sm text-gray-700">{needed}</p>
      </div>
    </div>
  </div>
);

export default BackendPendingNotice;
